<template>
  <div class="container-fluid" id="content">
    <div class="row justify-content-center">
      <div
        class="heading-calculation mb-4 card bg-success text-white rounded-2"
      >
        <div class="d-flex justify-content-between align-items-center p-3">
          <h1 class="mb-0">
            {{ $t("Property Distribution Calculation") }}
          </h1>
          <a
            @click="openRuleModal"
            class="btn btn-success border-white btn-hover"
            >{{ $t("RULES") }}</a
          >
        </div>
      </div>

      <div class="col-12">
        <div class="border-container p-3">
          <div class="relative-data">
            <h3 id="relative-heading">
              <i class="fa-solid fa-gift">&nbsp;&nbsp;</i
              >{{ $t("Relatives list") }}
            </h3>
          </div>
          <div class="row">
            <div
              v-for="data in displayedRelatives"
              :key="data.ENCRYPTED"
              class="relative-item col-sm-6 col-md-4 col-lg-4 col-xl-4"
              v-show="shouldShowRelative(data.ENCRYPTED)"
            >
              <label>
                <input
                  type="checkbox"
                  :value="data.ENCRYPTED"
                  v-model="selectedRelatives[data.ENCRYPTED]"
                  @change="onCheckboxChange(data)"
                />
                {{ data.RELATIVE }}
                <input
                  v-if="selectedRelatives[data.ENCRYPTED]"
                  type="number"
                  style="
                    width: 30px;
                    height: 20px;
                    margin-left: 5px;
                    text-align: center;
                  "
                  v-model.number="
                    formData.relative[`relative_no_${data.ENCRYPTED}`]
                  "
                  :value="1"
                  :readonly="isReadonlyField(data.ENCRYPTED)"
                />
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12 col-md-12 col-sm-12 mt-5">
        <div class="border-property p-3">
          <div class="relative-property">
            <h3 id="relative-heading">
              <i class="fa-solid fa-gift">&nbsp;&nbsp;</i
              >{{ $t("Property Description") }}
            </h3>
          </div>
          <div class="row">
            <div
              class="property-item col-xl-6 col-lg-6 col-md-6 col-sm-12 mt-3"
            >
              <label class="property-label">{{ $t("LAND") }}</label>
              <input
                type="number"
                class="property-input form-control"
                v-model="formData.land"
                style="width: 31%"
              />
              <span class="property-unit">{{ $t("DECIMAL") }}</span>
            </div>

            <div
              class="property-item col-xl-6 col-lg-6 col-md-6 col-sm-12 mt-3"
            >
              <label class="property-label">{{ $t("GOLD") }}</label>
              <input
                type="number"
                class="property-input form-control me-1"
                v-model="formData.gold"
                style="width: 31%"
              />
              <select
                class="form-select"
                v-model="formData.goldUnit"
                style="width: 98px"
              >
                <option value="gram">{{ $t("GRAM") }}</option>
                <option value="vori">{{ $t("Vori") }}</option>
              </select>
            </div>

            <div
              class="property-item col-xl-6 col-lg-6 col-md-6 col-sm-12 mt-3"
            >
              <label class="property-label">{{ $t("SILVER") }}</label>
              <input
                type="number"
                class="property-input form-control me-1"
                v-model="formData.silver"
                style="width: 31%"
              />
              <select
                class="form-select"
                v-model="formData.silverUnit"
                style="width: 98px"
              >
                <option value="gram">{{ $t("GRAM") }}</option>
                <option value="vori">{{ $t("Vori") }}</option>
              </select>
            </div>

            <div
              class="property-item col-xl-6 col-lg-6 col-md-6 col-sm-12 mt-3"
            >
              <label class="property-label">{{ $t("CURRENCY") }} </label>
              <input
                type="number"
                class="property-input form-control"
                v-model="formData.currency"
                style="width: 31%"
              />
              <span class="property-unit">{{ $t("TAKA") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="property-dist-result text-center"
    v-if="Object.keys(formData.relative).length > 0"
  >
    <input
      type="submit"
      @click="onSubmit"
      class="result"
      :value="$t('Result')"
    />
  </div>

  <div class="container-fluid" id="content" v-if="isSubmitted">
    <div class="row justify-content-center">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="border-property p-3">
          <div class="relative-property d-flex justify-content-between">
            <h3 id="relative-heading">
              <i class="fa-solid fa-gift">&nbsp;&nbsp;</i
              >{{ $t("Property Distribution Result") }}
            </h3>
            <div>
              <a
                @click="savePropertyDis"
                class="btn btn-warning text-white"
                v-if="isSubmitted"
              >
                {{ $t("Save Property") }}
              </a>
              <template v-if="hasCertificate">
                <a
                  @click="openCertificateModal"
                  class="btn btn-primary text-white me-2"
                >
                  {{ $t("Modify Certificate") }}
                </a>
                <a @click="printCertificate" class="btn btn-success text-white">
                  {{ $t("Print Certificate") }}
                </a>
              </template>
              <template v-else>
                <a
                  @click="openCertificateModal"
                  class="btn btn-primary text-white"
                >
                  {{ $t("Generate Certificate") }}
                </a>
              </template>
            </div>
          </div>
          <div class="row">
            <!-- Labels Div -->
            <div class="col-12 col-md-6 mt-5 m-auto text-center">
              <div class="d-inline-block text-start">
                <div
                  v-for="(label, index) in relativeDataList"
                  :key="index"
                  class="fw-bold mb-1 d-flex align-items-center"
                >
                  <span
                    :style="{
                      color: chartOptions.colors[index],
                      fontSize: '1.2em',
                      marginRight: '6px',
                    }"
                    >●</span
                  >
                  {{ label.relative_name + " - " + label.portion_part }}
                </div>
              </div>
            </div>

            <!-- Chart Div -->
            <div class="col-12 col-md-6 mt-4">
              <div id="chart">
                <apexchart
                  v-if="
                    series &&
                    series.length &&
                    chartOptions.labels &&
                    chartOptions.labels.length
                  "
                  ref="chart"
                  type="pie"
                  :options="chartOptions"
                  :series="series"
                >
                </apexchart>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-8 m-auto">
              <div
                class="row child-division mt-2"
                v-for="f in relativeDataList"
                :key="f"
              >
                <h2 class="mt-2">{{ f.relative_name }}</h2>
                <div class="custom-table shadow-xl">
                  <div>
                    <span class="fw-bold">
                      <p>{{ $t("LAND") }}</p>
                      <p class="unit">({{ $t("DECIMAL") }})</p>
                    </span>

                    <p class="values mt-4">{{ f.land_part }}</p>
                  </div>
                  <div>
                    <span class="fw-bold">
                      <p>{{ $t("GOLD") }}</p>
                      <p class="unit">({{ $t("Vori") }})</p>
                    </span>

                    <p class="values mt-4">{{ f.gold_part }}</p>
                  </div>
                  <div>
                    <span class="fw-bold">
                      <p>{{ $t("SILVER") }}</p>
                      <p class="unit">({{ $t("Vori") }})</p>
                    </span>

                    <p class="values mt-4">{{ f.silver_part }}</p>
                  </div>
                  <div>
                    <span class="fw-bold">
                      <p>{{ $t("CURRENCY") }}</p>
                      <p class="unit">({{ $t("TAKA") }})</p>
                    </span>

                    <p class="values mt-4">{{ f.currency_part }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid" id="content" v-else>
    <div
      class="row justify-content-center"
      v-if="propertyDistributionData.length > 0"
    >
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="border-property p-3">
          <div class="relative-property d-flex justify-content-between">
            <h3 id="relative-heading2">
              <i class="fa-solid fa-gift">&nbsp;&nbsp;</i
              >{{ $t("Property Distribution Result") }}
            </h3>
            <a
              @click="savePropertyDis"
              class="btn btn-warning text-white"
              v-if="isSubmitted"
            >
              {{ $t("Save Property") }}</a
            >
            <div v-if="hasCertificate">
              <a
                @click="openCertificateModal"
                class="btn btn-primary text-white me-2"
              >
                {{ $t("Modify Certificate") }}
              </a>
              <a @click="printCertificate" class="btn btn-success text-white">
                {{ $t("Download Certificate") }}
              </a>
            </div>
            <div v-else>
              <button
                :disabled="isLoading"
                @click="openCertificateModal"
                class="btn btn-primary text-white"
              >
                {{ $t("Generate Certificate") }}
              </button>
            </div>
          </div>
          <div class="row">
            <!-- Labels Div -->
            <div class="col-12 col-md-6 mt-5 m-auto text-center">
              <div class="d-inline-block text-start">
                <div
                  v-for="(label, index) in propertyDistributionData"
                  :key="index"
                  class="fw-bold mb-1 d-flex align-items-center"
                >
                  <span
                    :style="{
                      color: existingChartOptions.colors[index],
                      fontSize: '1.2em',
                      marginRight: '6px',
                    }"
                    >●</span
                  >
                  {{ label.relative_name + " - " + label.portion_part }}
                </div>
              </div>
            </div>

            <!-- Chart Div -->
            <div class="col-12 col-md-6 mt-4">
              <div id="chart" class="d-flex justify-content-center">
                <apexchart
                  type="pie"
                  width="380"
                  :options="existingChartOptions"
                  :series="series"
                ></apexchart>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-8 m-auto">
              <div
                class="row child-division mt-2"
                v-for="f in propertyDistributionData"
                :key="f"
              >
                <h2 class="mt-2">{{ f.relative_name }}</h2>
                <div class="custom-table shadow-xl">
                  <div>
                    <span class="fw-bold">
                      <p>{{ $t("LAND") }}</p>
                      <p class="unit">({{ $t("DECIMAL") }})</p>
                    </span>

                    <p class="values mt-4">{{ f.land_part }}</p>
                  </div>
                  <div>
                    <span class="fw-bold">
                      <p>{{ $t("GOLD") }}</p>
                      <p class="unit">({{ $t("Vori") }})</p>
                    </span>

                    <p class="values mt-4">{{ f.gold_part }}</p>
                  </div>
                  <div>
                    <span class="fw-bold">
                      <p>{{ $t("SILVER") }}</p>
                      <p class="unit">({{ $t("Vori") }})</p>
                    </span>

                    <p class="values mt-4">{{ f.silver_part }}</p>
                  </div>
                  <div>
                    <span class="fw-bold">
                      <p>{{ $t("CURRENCY") }}</p>
                      <p class="unit">({{ $t("TAKA") }})</p>
                    </span>

                    <p class="values mt-4">{{ f.currency_part }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- OTP Modal -->
  <div
    class="modal fade"
    id="otpModal"
    tabindex="-1"
    aria-labelledby="otpModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="otpModalLabel">Enter OTP</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="otpInput" class="form-label"
              >Please enter the OTP sent to your email</label
            >
            <input
              type="text"
              class="form-control"
              id="otpInput"
              v-model="otpInput"
              placeholder="Enter OTP"
              inputmode="numeric"
              maxlength="6"
              pattern="\d{6}"
            />
          </div>
          <div v-if="otpError" class="alert alert-danger">{{ otpError }}</div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            :disabled="isLoading"
            @click="verifyOTP"
          >
            Verify OTP
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- RULE Modal -->

  <div
    class="modal fade"
    id="ruleModal"
    tabindex="-1"
    aria-labelledby="ruleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="ruleModalLabel">{{ $t("RULES") }}</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <div v-if="lang == 'bn'">
              <p>
                <strong>জবিউল ফুরুজ:</strong> পবিত্র কোরআন শরীফে নির্ধারিত কিছু
                উত্তরাধিকারী আছেন, যাঁদের নির্দিষ্ট অংশ নির্ধারণ করে দেয়া হয়েছে।
                এদের বলা হয় <strong>জবিউল ফুরুজ</strong>। মোট ১২ জন অংশীদার এই
                দলে অন্তর্ভুক্ত। এর মধ্যে ৪ জন পুরুষ ও ৮ জন মহিলা।
              </p>

              <p>
                <strong>পুরুষ অংশীদার:</strong> (১) স্বামী, (২) পিতা, (৩) দাদা
                (পিতামহ), (৪) বৈপিত্রেয় ভাই।
              </p>
              <p>
                <strong>মহিলা অংশীদার:</strong> (১) স্ত্রী, (২) কন্যা, (৩)
                পুত্রের কন্যা, (৪) মাতা, (৫) দাদি ও নানি, (৬) সহোদর বোন, (৭)
                বৈমাত্রেয় বোন, (৮) বৈপিত্রেয় বোন।
              </p>

              <p>
                <strong>১.</strong> স্বামী ১/৪ অংশ পাবেন যদি সন্তান বা পুত্রের
                সন্তান থাকে।
              </p>
              <p>
                <strong>২.</strong> স্বামী ১/২ অংশ পাবেন যদি সন্তান বা পুত্রের
                সন্তান না থাকে।
              </p>
              <p>
                <strong>৩.</strong> স্ত্রী ১/৮ অংশ পাবেন যদি সন্তান বা পুত্রের
                সন্তান থাকে।
              </p>
              <p>
                <strong>৪.</strong> স্ত্রী ১/৪ অংশ পাবেন যদি সন্তান বা পুত্রের
                সন্তান না থাকে।
              </p>
              <p>
                <strong>৫.</strong> একজন মাত্র কন্যা থাকলে সে ১/২ অংশ পাবে, যদি
                পুত্র না থাকে।
              </p>
              <p>
                <strong>৬.</strong> দুই বা ততধিক কন্যা থাকলে তারা সম্মিলিতভাবে
                ২/৩ অংশ পাবে, যদি পুত্র না থাকে।
              </p>
              <p>
                <strong>৭.</strong> কন্যা অবশিষ্ট অংশ ভোগী হবেন যদি এক বা একাধিক
                পুত্র থাকে।
              </p>
              <p>
                <strong>৮.</strong> একজন মাত্র পুত্রের কন্যা থাকলে সে ১/২ অংশ
                পাবে, যদি পুত্র, পুত্রের পুত্র বা একাধিক কন্যা না থাকে।
              </p>
              <p>
                <strong>৯.</strong> দুই বা ততধিক পুত্রের কন্যা থাকলে তারা ২/৩
                অংশ পাবে, যদি পুত্র, পুত্রের পুত্র বা একাধিক কন্যা না থাকে।
              </p>
              <p>
                <strong>১০.</strong> পুত্রের কন্যা অবশিষ্ট অংশ ভোগী হবেন পুত্রের
                পুত্র না থাকলে এবং অন্যান্য নিষিদ্ধকারী অংশীদার না থাকলে।
              </p>
              <p>
                <strong>১১.</strong> পিতা ১/৬ অংশ পাবেন যদি পুত্র বা পুত্রের
                সন্তান থাকে।
              </p>
              <p>
                <strong>১২.</strong> পিতা অবশিষ্ট অংশ পাবেন যদি শুধুমাত্র কন্যা
                বা কন্যা ও পুত্রের কন্যা থাকে।
              </p>
              <p>
                <strong>১৩.</strong> পিতা সম্পূর্ণ অবশিষ্ট অংশ পাবেন যদি পুত্র
                বা পুত্রের পুত্র না থাকে।
              </p>
              <p>
                <strong>১৪.</strong> মাতা ১/৬ অংশ পাবেন যদি পুত্র, পুত্রের
                পুত্র, দুই বা ততধিক ভাইবোন ও পিতা থাকে।
              </p>
              <p>
                <strong>১৫.</strong> মাতা ১/৩ অংশ পাবেন যদি পুত্র, পুত্রের পুত্র
                বা একাধিক ভাইবোন না থাকে।
              </p>
              <p>
                <strong>১৬.</strong> স্বামী বা স্ত্রী ও পিতা থাকলে মাতা ১/৩ অংশ
                পাবেন অবশিষ্ট অংশের।
              </p>
              <p>
                <strong>১৭.</strong> দাদা ১/৬ অংশ পাবেন যদি সন্তান বা পুত্রের
                সন্তান থাকে এবং পিতা না থাকেন।
              </p>
              <p>
                <strong>১৮.</strong> দাদা অবশিষ্ট অংশ পাবেন যদি কন্যা অথবা
                পুত্রের কন্যা থাকে।
              </p>
              <p>
                <strong>১৯.</strong> দাদা অবশিষ্ট অংশ পাবেন যদি নিকটতম বাধা
                প্রদানকারী উত্তরাধিকারী না থাকে।
              </p>
              <p>
                <strong>২০.</strong> দাদি বা নানি ১/৬ অংশ পাবেন যদি মা অথবা অন্য
                দাদি না থাকেন।
              </p>
              <p>
                <strong>২১.</strong> একজন পূর্ণ (সহোদর) বোন ১/২ অংশ পাবেন যদি
                সন্তান, পুত্রের সন্তান, পিতা বা ভাই না থাকে।
              </p>
              <p>
                <strong>২২.</strong> দুই বা ততধিক পূর্ণ বোন থাকলে তারা ২/৩ অংশ
                পাবেন যদি উপরোক্ত কেউ না থাকে।
              </p>
              <p>
                <strong>২৩.</strong> পূর্ণ বোন অবশিষ্ট ভোগী হবেন যদি পুত্রের
                কন্যা ও পূর্ণ ভাই না থাকেন এবং বঞ্চনাকারী কেউ না থাকে।
              </p>
              <p>
                <strong>২৪.</strong> একজন বৈমাত্রেয় বোন ১/২ অংশ পাবেন যদি
                সন্তান, পুত্রের সন্তান, পিতা বা পূর্ণ ভাই না থাকেন।
              </p>
              <p>
                <strong>২৫.</strong> দুই বা ততধিক বৈমাত্রেয় বোন থাকলে তারা ২/৩
                অংশ পাবেন যদি উপরোক্ত বাধা প্রদানকারী না থাকে।
              </p>
              <p>
                <strong>২৬.</strong> একজন পূর্ণ বোন থাকলে সে ১/২ অংশ এবং
                বৈমাত্রেয় বোন ১/৬ অংশ পাবে।
              </p>
              <p>
                <strong>27.</strong> বৈমাত্রেয় বোন অবশিষ্ট ভোগী হবেন যদি
                বৈমাত্রেয় ভাই, কন্যা, পুত্রের কন্যা না থাকে এবং বাধা প্রদানকারী
                না থাকে।
              </p>
              <p>
                <strong>28.</strong> একজন বৈমাত্রেয় ভাই ১/৬ অংশ পাবেন যদি
                সন্তান, পুত্রের সন্তান ও পিতা না থাকে।
              </p>
              <p>
                <strong>29.</strong> দুই বা ততধিক বৈপিত্রেয় ভাই থাকলে তারা ১/৩
                অংশ ভাগ করে নেবেন যদি সন্তান, পুত্রের সন্তান ও পিতা না থাকে।
              </p>
              <p>
                <strong>30.</strong> একজন বৈপিত্রেয় বোন ১/৬ অংশ পাবেন যদি
                সন্তান, পুত্রের সন্তান ও পিতা না থাকে।
              </p>
              <p>
                <strong>31.</strong> দুই বা ততধিক বৈপিত্রেয় বোন থাকলে তারা ১/৩
                অংশ ভাগ করে নেবেন যদি উপরোক্ত বাধা প্রদানকারী না থাকে।
              </p>

              <p>
                <strong>৩২.</strong>
                <strong>১৯৬১ সালের মুসলিম পারিবারিক অধ্যাদেশ</strong> অনুযায়ী
                প্রতিনিধিত্ব নীতিতে বলা হয়েছে— যদি মৃত ব্যক্তি জীবিত থাকাকালীন
                তার সন্তান মারা যান, তাহলে তার সন্তানদের (নাতি-নাতনি) সেই
                সন্তানের অংশ দেওয়া হবে।
              </p>
            </div>

            <div v-else>
              <p>
                <strong>Zawil Furudh (Fixed Share Heirs):</strong> In the Holy
                Quran, specific heirs have been assigned fixed shares of
                inheritance. These heirs are known as
                <strong>Zawil Furudh</strong>. A total of 12 individuals fall
                under this category—4 males and 8 females.
              </p>

              <p>
                <strong>Male Heirs:</strong> (1) Husband, (2) Father, (3)
                Grandfather (Father’s father), (4) Uterine brother.
              </p>
              <p>
                <strong>Female Heirs:</strong> (1) Wife, (2) Daughter, (3) Son’s
                daughter, (4) Mother, (5) Grandmother (maternal and paternal),
                (6) Full sister, (7) Maternal half-sister, (8) Uterine
                half-sister.
              </p>

              <p>
                <strong>1.</strong> Husband will receive 1/4 if there are
                children or grandchildren from the son.
              </p>
              <p>
                <strong>2.</strong> Husband will receive 1/2 if there are no
                children or grandchildren from the son.
              </p>
              <p>
                <strong>3.</strong> Wife will receive 1/8 if there are children
                or grandchildren from the son.
              </p>
              <p>
                <strong>4.</strong> Wife will receive 1/4 if there are no
                children or grandchildren from the son.
              </p>
              <p>
                <strong>5.</strong> A single daughter will receive 1/2 if there
                are no sons.
              </p>
              <p>
                <strong>6.</strong> Two or more daughters will collectively
                receive 2/3 if there are no sons.
              </p>
              <p>
                <strong>7.</strong> A daughter will receive the residual share
                if there is one or more son.
              </p>
              <p>
                <strong>8.</strong> A single son's daughter will receive 1/2 if
                there are no sons, son’s sons, or multiple daughters.
              </p>
              <p>
                <strong>9.</strong> Two or more son’s daughters will receive 2/3
                if there are no sons, son’s sons, or multiple daughters.
              </p>
              <p>
                <strong>10.</strong> Son’s daughter will receive the residual
                share if there is no son’s son and no other blocking heirs.
              </p>
              <p>
                <strong>11.</strong> Father will receive 1/6 if there is a son
                or son’s son.
              </p>
              <p>
                <strong>12.</strong> Father will receive the residual share if
                only daughters or son’s daughters are present.
              </p>
              <p>
                <strong>13.</strong> Father will receive the full residual share
                if there is no son or son’s son.
              </p>
              <p>
                <strong>14.</strong> Mother will receive 1/6 if there are
                children, grandchildren (son’s side), two or more siblings, and
                father.
              </p>
              <p>
                <strong>15.</strong> Mother will receive 1/3 if there are no
                children, grandchildren, or multiple siblings.
              </p>
              <p>
                <strong>16.</strong> If husband/wife and father are present, the
                mother will receive 1/3 of the residual portion.
              </p>
              <p>
                <strong>17.</strong> Grandfather will receive 1/6 if there are
                children or grandchildren and no father.
              </p>
              <p>
                <strong>18.</strong> Grandfather will receive the residual share
                if there are daughters or son’s daughters.
              </p>
              <p>
                <strong>19.</strong> Grandfather will receive the residual share
                if there are no nearer blocking heirs.
              </p>
              <p>
                <strong>20.</strong> Grandmother (maternal or paternal) will
                receive 1/6 if the mother or another grandmother is not alive.
              </p>
              <p>
                <strong>21.</strong> One full sister will receive 1/2 if there
                are no children, grandchildren, father, or brothers.
              </p>
              <p>
                <strong>22.</strong> Two or more full sisters will collectively
                receive 2/3 if the above are not present.
              </p>
              <p>
                <strong>23.</strong> Full sister will receive the residual share
                if there are no son’s daughters or full brothers and no blocking
                heirs.
              </p>
              <p>
                <strong>24.</strong> One maternal half-sister will receive 1/2
                if there are no children, grandchildren, father, or full
                brothers.
              </p>
              <p>
                <strong>25.</strong> Two or more maternal half-sisters will
                receive 2/3 if there are no blocking heirs as mentioned.
              </p>
              <p>
                <strong>26.</strong> If there is one full sister, she will
                receive 1/2, and the maternal half-sister will receive 1/6.
              </p>
              <p>
                <strong>27.</strong> Maternal half-sister will receive the
                residual share if there are no maternal half-brothers,
                daughters, or son’s daughters, and no blocking heirs.
              </p>
              <p>
                <strong>28.</strong> One uterine brother will receive 1/6 if
                there are no children, grandchildren, or father.
              </p>
              <p>
                <strong>29.</strong> Two or more uterine brothers will receive
                1/3 collectively if there are no children, grandchildren, or
                father.
              </p>
              <p>
                <strong>30.</strong> One uterine sister will receive 1/6 if
                there are no children, grandchildren, or father.
              </p>
              <p>
                <strong>31.</strong> Two or more uterine sisters will receive
                1/3 collectively if there are no blocking heirs.
              </p>

              <p>
                <strong>32.</strong> According to the
                <strong>Muslim Family Ordinance, 1961</strong>, under the
                principle of representation—if a child of the deceased had
                passed away before them, then the deceased child’s share shall
                be given to their children (i.e., the grandchildren).
              </p>

              <p>
                <strong>33.</strong> <strong>Radd:</strong> Radd refers to a
                situation where, after distributing the fixed shares (Furudh)
                among the entitled heirs (Zawil Furudh), a portion of the estate
                remains and there are no residuary heirs (Asabah). In that case,
                the remaining portion is redistributed among the Zawil Furudh
                heirs proportionally to their original shares.
              </p>

              <p>
                <strong>34.</strong> <strong>Awl:</strong> Awl refers to a
                situation where the total of the fixed shares of the Zawil
                Furudh heirs exceeds the whole estate (i.e., more than 1). In
                such cases, each share is proportionally reduced so the total
                remains within one unit (the full estate).
              </p>
            </div>
          </div>
          <div v-if="otpError" class="alert alert-danger">{{ otpError }}</div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios';
import VueApexCharts from "vue3-apexcharts";
import { toast } from "vue3-toastify";
import apiRepository, { getMediaInfo } from "@/services/ApiRepository";
import * as bootstrap from "bootstrap";
import Swal from "sweetalert2";

export default {
  name: "CalCualtion",
  components: {
    apexchart: VueApexCharts,
  },

  data() {
    return {
      propertyDistributionData: [],
      formData: {
        land: "",
        gold: "",
        silver: "",
        currency: "",
        relative: {},
        goldUnit: "gram",
        silverUnit: "gram",
      },
      lang: "",
      conversionRate: {
        voriToGram: 11.66, // Conversion rate: 1 vori = 11.66 grams
      },
      isSubmitted: false,
      Result: "Result",
      relativeData: [],
      relativeDataList: [],
      selectedRelatives: {}, // Initialize as an empty object
      relative: {},
      series: [],
      legend: {
        show: false,
      },
      chartOptions: {
        chart: {
          type: "pie",
        },
        labels: [],
        colors: [],
      },
      existingChartOptions: {
        chart: {
          type: "pie",
        },
        labels: [],
        colors: [],
      },

      dynamicChildren: {
        son: [],
        daughter: [],
      },
      encryptedKeys: {
        deceasedSon: "aTZX79XB0XkeLgERIo2OIw==",
        deceasedDaughter: "20wmeXeB57v9gv5lN+jWrA==",
        deceasedSonSon: "HpOMjLTogw9LacBtPZnBYw==",
        deceasedSonDaughter: "UX3C0ze3peC15PxKMKcLKw==",
        deceasedDaughterSon: "rKt0JEpkWRnmry8/vxHLHg==",
        deceasedDaughterDaughter: "oWmEwQJfpNvTtt5jYXWsoA==",
      },
      otpInput: "",
      otpError: "",
      otpModal: null,
      ruleModal: null,
      certificateModal: null,
      hasCertificate: false,
      certificateData: [],
      isLoading: false,
      certificateUrl: "",
    };
  },

  mounted() {
    this.fetchRelativeData();
    this.getPropertyData();
    this.checkCertificateStatus();
    this.langData();

    // Initialize Bootstrap modal
    this.$nextTick(() => {
      const otpModalElement = document.getElementById("otpModal");
      const ruleModalElement = document.getElementById("ruleModal");
      const certificateModalElement =
        document.getElementById("certificateModal");
      if (otpModalElement) {
        this.otpModal = new bootstrap.Modal(otpModalElement);
      }
      if (ruleModalElement) {
        this.ruleModal = new bootstrap.Modal(ruleModalElement);
      }
      if (certificateModalElement) {
        this.certificateModal = new bootstrap.Modal(certificateModalElement);
      }
    });
  },

  computed: {
    displayedRelatives() {
      const result = [];
      for (const data of this.relativeData) {
        result.push(data);
        if (data.ENCRYPTED === this.encryptedKeys.deceasedSon) {
          result.push(...this.dynamicChildren.son);
        }
        if (data.ENCRYPTED === this.encryptedKeys.deceasedDaughter) {
          result.push(...this.dynamicChildren.daughter);
        }
      }
      return result;
    },
  },
  methods: {
    langData() {
      const langu = localStorage.getItem("locale");
      this.lang = langu;
    },
    onSubmit() {
      const goldValue = parseFloat(this.formData.gold) || 0;
      const silverValue = parseFloat(this.formData.silver) || 0;
      const result = {
        relative: [this.formData.relative],
        propertyLand: parseFloat(this.formData.land) || 0,
        propertyGold:
          this.formData.goldUnit === "vori" ? goldValue * 11.66 : goldValue,
        propertySilver:
          this.formData.silverUnit === "vori"
            ? silverValue * 11.66
            : silverValue,
        propertyTk: parseFloat(this.formData.currency) || 0,
      };
      console.log(result);
      const lang = localStorage.getItem("locale");

      apiRepository
        .callApi(
          apiRepository.POST_COMMAND,
          `/propertyDistributeResult?lang=${lang}`,
          result
        )
        .then((res) => {
          if (res.data) {
            this.relativeDataList = res.data;
            this.isSubmitted = true;

            const seriesData = this.relativeDataList.map((item) =>
              isNaN(this.castToInteger(item.portion_part))
                ? 0
                : this.castToInteger(item.portion_part)
            );

            const labelsData = this.relativeDataList.map(
              (item) => item.relative_name || "Unknown"
            );

            // Check if data is valid before updating the chart
            if (seriesData.length > 0 && labelsData.length > 0) {
              this.updateChartData(seriesData, labelsData);
            } else {
              console.error("Invalid series or labels data");
              // toast.error("No valid data to update chart");
              this.series = [];
              this.chartOptions = {
                ...this.chartOptions,
                labels: [],
                colors: [],
              };
            }
          } else {
            toast.error("Please fill out all fields!");
          }
        });
    },

    generateColors(length) {
      const colors = [];
      for (let i = 0; i < length; i++) {
        let color = `#${Math.floor(Math.random() * 16777215).toString(16)}`; // Random color
        while (color.length !== 7) {
          color = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
        }
        colors.push(color);
      }
      return colors;
    },

    updateChartData(seriesData, labelsData) {
      if (
        !Array.isArray(seriesData) ||
        !Array.isArray(labelsData) ||
        seriesData.length === 0 ||
        labelsData.length === 0
      ) {
        console.error("Invalid seriesData or labelsData");
        return;
      }
      this.series = seriesData; // Update series with the data
      //  this.chartOptions.labels = labelsData; // Update labels
      //  this.chartOptions.colors = this.generateColors(seriesData.length); // Generate random colors for each segment
      this.chartOptions = {
        ...this.chartOptions,
        labels: labelsData,
        colors: this.generateColors(seriesData.length),
      };
      this.existingChartOptions = {
        ...this.existingChartOptions,
        labels: labelsData,
        colors: this.generateColors(seriesData.length),
      };
    },
    savePropertyDis() {
      if (
        this.relativeDataList.length > 0 ||
        !this.relativeDataList.isEmpty()
      ) {
        apiRepository.savePropertyDetails(this.relativeDataList).then((res) => {
          if (res) {
            toast.success(res.data || "RECORD INSERTED SUCCESSFULLY!!");
          } else {
            toast.error(res.data || "Data Not Found!");
          }
        });
      } /*else {
                    return;
                }*/
    },
    getPropertyData() {
      apiRepository.getPropertyDistribute().then((res) => {
        if (res) {
          this.propertyDistributionData = res.data;
          let seriesData = [];
          let labelsData = [];
          seriesData = this.propertyDistributionData.map((item) => {
            const portionPart = this.castToInteger(item.portion_part);

            // console.log('kire kire', portionPart);
            if (isNaN(portionPart) || portionPart === null) {
              console.error("Invalid portion part:", item.portion_part);
              return 0; // Default to 0 if invalid
            }
            return portionPart;
          });

          labelsData = this.propertyDistributionData.map((item) => {
            const relativeName = item.relative_name || "Unknown";
            return relativeName;
          });

          // Check if data is valid before updating the chart
          if (seriesData.length > 0 && labelsData.length > 0) {
            this.updateChartData(seriesData, labelsData);
          } else {
            console.error("Invalid series or labels data");
            // toast.error("No valid data to update chart");
            this.series = [];
            this.existingChartOptions = {
              ...this.existingChartOptions,
              labels: [],
              colors: [],
            };
          }
        }
      });
    },

    async fetchRelativeData() {
      try {
        const res = await apiRepository.getRelevantList();
        this.relativeData = res || []; // Ensure relativeData is always an array

        if (this.relativeData.length > 0) {
          for (const key in this.relativeData[0]) {
            this.$set(this.selectedRelatives, key, false);
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    convertToGrams(value, unit) {
      const numericValue = value;
      if (isNaN(numericValue) || numericValue === 0) {
        return ""; // Return an empty string for invalid or zero values
      }

      if (unit === "vori") {
        return (numericValue / this.conversionRate.voriToGram).toFixed(2);
      }
      if (unit === "gram") {
        return (numericValue * this.conversionRate.voriToGram).toFixed(2);
      }

      return numericValue.toFixed(2); // Default is grams
    },

    updateGoldValue() {
      this.formData.gold = this.convertToGrams(
        this.formData.gold,
        this.formData.goldUnit
      );
    },

    updateSilverValue() {
      this.formData.silver = this.convertToGrams(
        this.formData.silver,
        this.formData.silverUnit
      );
    },

    onCheckboxChange(data) {
      const encrypted = data.ENCRYPTED;
      const deceasedSonKey = this.encryptedKeys.deceasedSon;
      const deceasedDaughterKey = this.encryptedKeys.deceasedDaughter;

      // Handle default value for checked items
      if (this.selectedRelatives[encrypted]) {
        this.formData.relative[`relative_no_${encrypted}`] = 1;

        // Handle dynamic children generation for Deceased Son
        if (encrypted === deceasedSonKey) {
          this.updateDynamicChildren("son");
        }
        // Handle dynamic children generation for Deceased Daughter
        else if (encrypted === deceasedDaughterKey) {
          this.updateDynamicChildren("daughter");
        }
      } else {
        delete this.formData.relative[`relative_no_${encrypted}`];
        // Clear dynamic children when parent is unchecked
        if (encrypted === deceasedSonKey) {
          this.dynamicChildren.son = [];
        } else if (encrypted === deceasedDaughterKey) {
          this.dynamicChildren.daughter = [];
        }
      }
      this.validateDependencies(encrypted);
    },

    isReadonlyField(encrypted) {
      const readonlyList = [
        "ES+jQvYP4Jfl7olyUlJ9RQ==",
        "j1mjV6qs9iab4mbEVNyg0A==",
        "zkX+xHUpZv1cdAjWQHiLxg==",
        "P1EMaXcfDjHvaG3FENSJ0g==",
      ];
      return readonlyList.includes(encrypted);
      // return encrypted === "j1mjV6qs9iab4mbEVNyg0A==";
    },

    updateDynamicChildren(type) {
      const parentKey =
        type === "son"
          ? this.encryptedKeys.deceasedSon
          : this.encryptedKeys.deceasedDaughter;
      const count =
        parseInt(this.formData.relative[`relative_no_${parentKey}`]) || 1;
      const lang = localStorage.getItem("locale");

      // Store current checked state and input values
      const prevChildren = this.dynamicChildren[type] || [];
      const prevChecked = {};
      const prevValues = {};
      for (const child of prevChildren) {
        prevChecked[child.ENCRYPTED] = this.selectedRelatives[child.ENCRYPTED];
        prevValues[child.ENCRYPTED] =
          this.formData.relative[`relative_no_${child.ENCRYPTED}`];
      }

      const children = [];

      for (let i = 1; i <= count; i++) {
        const base = `Deceased ${i}${this.getOrdinalSuffix(i)} ${
          type === "son" ? "Son" : "Daughter"
        }`;

        const sonKey = `${type}_son_${i}`;
        const daughterKey = `${type}_daughter_${i}`;

        children.push({
          ENCRYPTED: sonKey,
          RELATIVE:
            lang === "bn"
              ? this.translateRelativeToBn(`${base}'s Son`)
              : `${base}'s Son`,
        });

        children.push({
          ENCRYPTED: daughterKey,
          RELATIVE:
            lang === "bn"
              ? this.translateRelativeToBn(`${base}'s Daughter`)
              : `${base}'s Daughter`,
        });
      }
      this.dynamicChildren[type] = children;

      // Restore checked state and input values
      for (const child of children) {
        if (prevChecked[child.ENCRYPTED] !== undefined) {
          this.selectedRelatives[child.ENCRYPTED] =
            prevChecked[child.ENCRYPTED];
        }
        if (prevValues[child.ENCRYPTED] !== undefined) {
          this.formData.relative[`relative_no_${child.ENCRYPTED}`] =
            prevValues[child.ENCRYPTED];
        }
      }
    },

    getOrdinalSuffix(num) {
      const j = num % 10;
      const k = num % 100;
      if (j === 1 && k !== 11) return "st";
      if (j === 2 && k !== 12) return "nd";
      if (j === 3 && k !== 13) return "rd";
      return "th";
    },

    validateDependencies(encrypted) {
      const husbandKey = "j1mjV6qs9iab4mbEVNyg0A==";
      const wifeKey = "L3KSP53cxd1tnhTXblgTZw==";
      const deceasedSonKey = this.encryptedKeys.deceasedSon;
      const deceasedSonSonKey = this.encryptedKeys.deceasedSonSon;
      const deceasedSonDaughterKey = this.encryptedKeys.deceasedSonDaughter;
      const deceasedDaughterKey = this.encryptedKeys.deceasedDaughter;
      const deceasedDaughterSonKey = this.encryptedKeys.deceasedDaughterSon;
      const deceasedDaughterDaughterKey =
        this.encryptedKeys.deceasedDaughterDaughter;

      // Handle Husband-Wife mutual exclusivity
      if (
        this.selectedRelatives[husbandKey] &&
        this.selectedRelatives[wifeKey]
      ) {
        toast.error(
          "You cannot select both Husband and Wife at the same time."
        );
        if (encrypted === husbandKey) {
          this.selectedRelatives[wifeKey] = false;
          delete this.formData.relative[`relative_no_${wifeKey}`];
        } else if (encrypted === wifeKey) {
          this.selectedRelatives[husbandKey] = false;
          delete this.formData.relative[`relative_no_${husbandKey}`];
        }
      }

      // Handle Deceased Son dependencies
      if (encrypted === deceasedSonKey) {
        if (!this.selectedRelatives[deceasedSonKey]) {
          // If Deceased Son is unchecked, uncheck and remove his children
          this.selectedRelatives[deceasedSonSonKey] = false;
          this.selectedRelatives[deceasedSonDaughterKey] = false;
          delete this.formData.relative[`relative_no_${deceasedSonSonKey}`];
          delete this.formData.relative[
            `relative_no_${deceasedSonDaughterKey}`
          ];
        }
      }

      // Handle Deceased Daughter dependencies
      if (encrypted === deceasedDaughterKey) {
        if (!this.selectedRelatives[deceasedDaughterKey]) {
          // If Deceased Daughter is unchecked, uncheck and remove her children
          this.selectedRelatives[deceasedDaughterSonKey] = false;
          this.selectedRelatives[deceasedDaughterDaughterKey] = false;
          delete this.formData.relative[
            `relative_no_${deceasedDaughterSonKey}`
          ];
          delete this.formData.relative[
            `relative_no_${deceasedDaughterDaughterKey}`
          ];
        }
      }

      // Update all selected relatives in formData
      Object.keys(this.selectedRelatives).forEach((key) => {
        if (this.selectedRelatives[key]) {
          if (
            this.formData.relative[`relative_no_${key}`] === undefined ||
            this.formData.relative[`relative_no_${key}`] === "" ||
            this.formData.relative[`relative_no_${key}`] === null
          ) {
            this.formData.relative[`relative_no_${key}`] = 1;
          }
        } else {
          delete this.formData.relative[`relative_no_${key}`];
        }
      });
    },

    // Method to update chart data and colors
    castToInteger(value) {
      if (value == null) return 0; // Handle null or undefined input

      // Convert value to a string for safe processing
      let valueStr = value.toString();

      // Replace Bengali numerals with English numerals
      valueStr = valueStr
        .replace(/০/g, "0")
        .replace(/১/g, "1")
        .replace(/২/g, "2")
        .replace(/৩/g, "3")
        .replace(/৪/g, "4")
        .replace(/৫/g, "5")
        .replace(/৬/g, "6")
        .replace(/৭/g, "7")
        .replace(/৮/g, "8")
        .replace(/৯/g, "9");

      const parsedValue = parseFloat(valueStr);

      // Return the result, ensuring it's a valid number
      return isNaN(parsedValue) ? 0 : parsedValue;
    },

    shouldShowRelative(encrypted) {
      const deceasedSonKey = this.encryptedKeys.deceasedSon;
      const deceasedSonSonKey = this.encryptedKeys.deceasedSonSon;
      const deceasedSonDaughterKey = this.encryptedKeys.deceasedSonDaughter;
      const deceasedDaughterKey = this.encryptedKeys.deceasedDaughter;
      const deceasedDaughterSonKey = this.encryptedKeys.deceasedDaughterSon;
      const deceasedDaughterDaughterKey =
        this.encryptedKeys.deceasedDaughterDaughter;

      // Hide static children if dynamic children are present
      if (
        (encrypted === deceasedSonSonKey ||
          encrypted === deceasedSonDaughterKey) &&
        this.selectedRelatives[deceasedSonKey] &&
        parseInt(this.formData.relative[`relative_no_${deceasedSonKey}`]) >= 1
      ) {
        return false;
      }
      if (
        (encrypted === deceasedDaughterSonKey ||
          encrypted === deceasedDaughterDaughterKey) &&
        this.selectedRelatives[deceasedDaughterKey] &&
        parseInt(
          this.formData.relative[`relative_no_${deceasedDaughterKey}`]
        ) >= 1
      ) {
        return false;
      }

      // Show Deceased Daughter's children only if Deceased Daughter is selected
      if (
        encrypted === deceasedDaughterSonKey ||
        encrypted === deceasedDaughterDaughterKey
      ) {
        return this.selectedRelatives[deceasedDaughterKey];
      }

      // Show Deceased Son's children only if Deceased Son is selected
      if (
        encrypted === deceasedSonSonKey ||
        encrypted === deceasedSonDaughterKey
      ) {
        return this.selectedRelatives[deceasedSonKey];
      }

      // Check if it's a dynamic child
      if (encrypted.startsWith("son_") || encrypted.startsWith("daughter_")) {
        const type = encrypted.startsWith("son_") ? "son" : "daughter";
        const parentKey = type === "son" ? deceasedSonKey : deceasedDaughterKey;
        return this.selectedRelatives[parentKey];
      }

      // Show all other relatives
      return true;
    },

    translateRelativeToBn(relativeKey) {
      if (!relativeKey) return "";

      let isDeceased = false;
      let key = relativeKey;

      // Step 1: Check and remove "Deceased"
      if (key.startsWith("Deceased ")) {
        isDeceased = true;
        key = key.replace("Deceased ", "");
      }

      // Step 2: Split by "'s "
      const parts = key.split("'s ");
      if (parts.length !== 2) return relativeKey;

      const parentPart = parts[0].trim(); // e.g., "1st Son"
      const childPart = parts[1].trim(); // e.g., "Daughter"

      // Step 3: Extract ordinal and relation
      const ordinal = parentPart.replace(/[^0-9]/g, "");
      const parentType = parentPart
        .replace(/[0-9]/g, "")
        .replace(/(st|nd|rd|th)/g, "")
        .trim();

      // Step 4: Translate to Bangla
      const bnOrdinal = this.convertNumberToBn(ordinal);
      const bnParent = this.translateRelationToBn(parentType);
      const bnChild = this.translateRelationToBn(childPart);

      // Step 5: Construct
      let result = "";
      if (isDeceased) result += "মৃত ";
      result += `${bnParent} ${bnOrdinal} এর ${bnChild}`;

      return result.trim();
    },

    translateRelationToBn(relation) {
      const map = {
        son: "পুত্র",
        daughter: "কন্যা",
      };
      return map[relation.toLowerCase()] || relation;
    },

    convertNumberToBn(numStr) {
      const enToBn = {
        0: "০",
        1: "১",
        2: "২",
        3: "৩",
        4: "৪",
        5: "৫",
        6: "৬",
        7: "৭",
        8: "৮",
        9: "৯",
      };
      return numStr
        .split("")
        .map((d) => enToBn[d] || d)
        .join("");
    },

    async checkCertificateStatus() {
      try {
        const response = await apiRepository.getCertificateInfo();
        if (response && response.data) {
          this.certificateData = response.data.data;
          this.certificateUrl = response.data.certificateUrl;
          this.hasCertificate = true;
          // console.log("Certificate exists:", this.hasCertificate); // Debug log
        } else {
          this.hasCertificate = false;
        }
      } catch (error) {
        console.error("Error checking certificate status:", error);
        this.hasCertificate = false;
      }
    },

    async openCertificateModal() {
      if (this.hasCertificate) {
        const result = await Swal.fire({
          title: "Modify Certificate?",
          text: "Are you sure to modify your certificate on your saved latest property distribution record & language basis?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, modify it!",
          cancelButtonText: "Cancel",
          reverseButtons: true,
        });

        if (!result.isConfirmed) {
          return; // User cancelled
        }
      }
      this.isLoading = true;
      const toastId = toast.loading("Processing your request...");
      try {
        let response;
        if (this.hasCertificate) {
          response = await apiRepository.modifyCertificate();
        } else {
          response = await apiRepository.sendCertificateOTP();
          this.otpModal.show();
        }
        if (response && response.data) {
          toast.update(toastId, {
            render: response?.data,
            type: "success",
            isLoading: false,
            autoClose: 3000,
            closeOnClick: true,
          });

        }
      } catch (error) {
        console.error("Error sending OTP:", error);
        toast.update(toastId, {
          render: error.response?.data || "Failed to send OTP",
          type: "error",
          isLoading: false,
          autoClose: 3000,
          closeOnClick: true,
        });
      } finally {
        this.isLoading = false; // Stop loading
      }
    },

    async openRuleModal() {
      this.ruleModal.show();
    },

    async printCertificate() {
      try {
        const response = await fetch(getMediaInfo() + this.certificateUrl);
        if (!response.ok) {
          throw new Error(
            `Failed to fetch file: ${response.status} ${response.statusText}`
          );
        }

        const data = await response.json();

        // Decode base64 content and convert to byte array
        const byteCharacters = atob(data.content);
        const byteArray = new Uint8Array(
          Array.from(byteCharacters, (char) => char.charCodeAt(0))
        );

        const contentType = data.contentType || "application/octet-stream";
        const blob = new Blob([byteArray], { type: contentType });

        // Trigger download
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = "Certificate";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error("Download failed:", error);
        toast.error("🚫 Failed to download the certificate. Please try again.");
      }
    },

    async verifyOTP() {
      if (!this.otpInput) {
        this.otpError = "Please enter the OTP";
        return;
      }
      this.isLoading = true;
      const toastId = toast.loading("Verifying OTP...");
      try {
        // Call API to verify OTP and generate certificate
        const response = await apiRepository.verifyCertificateOTP(
          this.otpInput
        );
        if (response?.data) {
          toast.update(toastId, {
            render: response?.data,
            type: "success",
            isLoading: false,
            autoClose: 3000,
            closeOnClick: true,
          });

          this.otpModal.hide();
          await this.checkCertificateStatus();
          this.otpInput = "";
          this.otpError = "";
        } else {
          this.otpError = "Invalid OTP. Please try again.";
        }
      } catch (error) {
        console.error("Error verifying OTP:", error);
        toast.update(toastId, {
          render: error.response?.data || "Failed to verify OTP",
          type: "error",
          isLoading: false,
          autoClose: 3000,
          closeOnClick: true,
        });
      } finally {
        this.isLoading = false; // Stop loading
      }
    },
  },

  watch: {
    "formData.relative.relative_no_aTZX79XB0XkeLgERIo2OIw==": function () {
      if (this.selectedRelatives[this.encryptedKeys.deceasedSon]) {
        this.updateDynamicChildren("son");
      }
    },
    "formData.relative.relative_no_20wmeXeB57v9gv5lN+jWrA==": function () {
      if (this.selectedRelatives[this.encryptedKeys.deceasedDaughter]) {
        this.updateDynamicChildren("daughter");
      }
    },
    certificateData: {
      handler(newVal) {
        this.hasCertificate = Array.isArray(newVal) && newVal.length > 0;
        /*console.log(
                        "Certificate data changed, hasCertificate:",
                        this.hasCertificate
                    );*/ // Debug log
      },
      immediate: true,
    },
  },
};
</script>

<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

/*** Spinner Start ***/

/*** Spinner ***/

#spinner {
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.5s ease-out, visibility 0s linear 0.5s;
  z-index: 99999;
}

#spinner.show {
  transition: opacity 0.5s ease-out, visibility 0s linear 0s;
  visibility: visible;
  opacity: 1;
}

/*** Spinner End ***/
.top-up-down {
  justify-content: right;
}

.top-up-down .back-to-top {
  bottom: 20px;
  right: 20px;
  display: flex;
  position: fixed !important;
  align-items: center;
  /* Center vertically */
  justify-content: center !important;
  /* Center horizontally (for now) */
  background-color: #007bff;
  color: #fff;
  /* border-radius: 50%;
              transition: 0.3s; */
  z-index: 99;
  /* opacity: 0; */
  visibility: hidden;
}

/* Show the button when scrolled down */
.top-up-down .back-to-top.show {
  opacity: 1;
  visibility: visible;
}

/* Optional hover effect */
.back-to-top:hover {
  background-color: #74009e;
}

/*** Button Start ***/

.btn {
  font-weight: 600;
  transition: 0.5s;
}

.btn-square {
  width: 32px;
  height: 32px;
}

.btn-sm-square {
  width: 34px;
  height: 34px;
}

.btn-md-square {
  width: 44px;
  height: 44px;
}

.btn-lg-square {
  width: 56px;
  height: 56px;
}

.btn-square,
.btn-sm-square,
.btn-md-square,
.btn-lg-square {
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: normal;
  border-radius: 50%;
}

.btn.btn-primary {
  box-shadow: inset 0 0 0 0 #6f00cdff;
  /*box-shadow: inset 0 0 0 0 var(--bs-primary);*/
}

.btn.btn-primary:hover {
  box-shadow: inset 300px 0 0 0 var(--bs-light) !important;
  color: #ff4900 !important;
  /*color: var(--bs-primary) !important;*/
}

.btn.btn-light {
  box-shadow: inset 0 0 0 0 #6f00cdff;
  /*box-shadow: inset 0 0 0 0 var(--bs-primary);*/
}

.btn.btn-light:hover {
  box-shadow: inset 300px 0 0 0 #6f00cdff;
  /*box-shadow: inset 300px 0 0 0 var(--bs-primary);*/
  color: var(--bs-light) !important;
}

.btn-hover {
  transition: 0.5s;
}

.btn-hover:hover {
  color: var(--bs-secondary) !important;
}

/*** Section Title Start ***/

.section-title {
  position: relative;
  display: inline-block;
  text-transform: uppercase;
  color: #6f00cdff;
  /*color: var(--bs-primary);*/
}

.section-title::before {
  content: "";
  width: 50px;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  margin-right: -50px;
  border: 1px solid #6f00cdff !important;
  /*border: 1px solid var(--bs-primary) !important;*/
}

.section-title::after {
  content: "";
  width: 50px;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  margin-left: -50px;
  border: 1px solid #6f00cdff !important;
  /*border: 1px solid var(--bs-primary) !important;*/
}

/*** Topbar Start ***/

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: #077747 !important;
}

.bg-breadcrumb .breadcrumb-item a {
  color: var(--bs-secondary) !important;
}

/*** Single Page Hero Header End ***/

/*Start Content Style*/
#content {
  padding-top: 30px;
}

.border-container {
  border: 1px solid #000;
  /* Adjust border thickness and color as needed */
  padding: 20px;
  margin-bottom: 30px;
  border-radius: 5px 5px 0 0;
  /* Optional: rounded corners */
  background-color: #fff;
  /* Adjust background color as needed */
}

.relative-data {
  text-align: left;
  margin-top: 0;
  margin-bottom: 20px;
  background-color: #077747;
  color: #ffffff;
  padding: 5px;
  border-bottom: 1px solid #000;
  /* Border between heading and items */
  border-radius: 5px 5px 0 0;
  box-shadow: 0 -4px 6px -4px rgba(0, 0, 0, 1);
}

.relative-item {
  margin-bottom: 10px;
}

.relative-item label {
  display: flex;
  align-items: center;
}

.relative-item input[type="checkbox"] {
  margin-right: 10px;
}

.relative-property {
  text-align: left;
  margin-top: 0;
  margin-bottom: 20px;
  background-color: #077747;
  color: #ffffff;
  padding: 5px;
  border-bottom: 1px solid #000;
  /* Border between heading and items */
  border-radius: 5px 5px 0 0;
  box-shadow: 0 -4px 6px -4px rgba(0, 0, 0, 1);
}

.border-property {
  border: 1px solid #000;
  padding: 20px;
  margin-bottom: 30px;
  border-radius: 5px 5px 0 0;
  background-color: #fff;
}

.property-item {
  display: flex;
  align-items: center;
}

.property-label {
  width: 90px;
  text-align: right;
  margin-right: 10px;
}

.property-unit {
  margin-left: 10px;
}

.property-dist-result .result {
  background-color: #077747;
  border-radius: 5px;
  color: #ffffff;
  width: 100px;
  height: 50px;
  margin-bottom: 20px;
  box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1),
    0 8px 10px -6px rgb(0 0 0 / 0.1);
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
  text-align: center;
}

.print-button {
  margin-top: 1rem;
  background-color: #077747;
  color: white;
}

@media print {
  .print-button {
    display: none;
  }
}

/*Start Content Style End*/

/*** About Start ***/

.about .container .section-about-title {
  position: relative;
  display: inline-block;
  text-transform: uppercase;
  color: #6f00cdff;
  /*color: var(--bs-primary);*/
}

.about .container .section-about-title::before {
  content: "";
  width: 50px;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  margin-right: -50px;
  border: 1px solid #6f00cdff !important;
  /*border: 1px solid var(--bs-primary) !important;*/
}

/*** About End ***/

.child-division {
  border: 2px solid #6f00cd;
  border-radius: 10px;
}

.custom-table {
  display: flex;
  justify-content: space-around;
  font-size: 18px;
}

.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1),
    0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color),
    0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  padding: 2rem;
}

.custom-table div {
  flex: 1;
  text-align: center;
}

.custom-table div:not(:last-child) {
  border-right: 1px solid black;
}

.custom-table div p {
  margin: 5px 0;
}

/* OTP Modal Styles */
.modal-content {
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.modal-header {
  background-color: #077747;
  color: white;
  border-radius: 8px 8px 0 0;
}

.modal-header .btn-close {
  color: white;
  filter: brightness(0) invert(1);
}

.modal-body {
  padding: 20px;
}

.form-label {
  font-weight: 500;
  color: #333;
}

#otpInput {
  font-size: 1.2rem;
  letter-spacing: 0.3em;
  text-align: center;
  padding: 10px;
}

.alert-danger {
  margin-top: 10px;
  padding: 10px;
  border-radius: 4px;
}

.modal-footer {
  border-top: 1px solid #dee2e6;
  padding: 15px 20px;
}

.modal-footer .btn {
  padding: 8px 20px;
  font-weight: 500;
}
</style>
